export const Footer = () => {
  return (
    <footer className="mt-20 lg:mt-36">
      <hr className="w-11/12 m-auto" />
      <div className="text-sm py-5 w-11/12 m-auto text-center lg:p-10 lg:flex justify-between">
        <h1>Email : ramadika380@gmail.com</h1>
        <h1 className="hidden lg:block">- DKWP -</h1>
        <h1>Ramadika Wijaya Poetra S © 2023 </h1>
      </div>
    </footer>
  );
};
